import { useMutation, useQuery, useQueryClient } from "react-query";

import api from "../../utils/api";
import { useHubSnackBar } from "../useSnackBar";
import { invalidate } from "../../helpers/clientHelper";

const USER = "/user";

const getUserProfileById = (id) => api.get(`${USER}/${id}`);

export const useGetUserProfile = (id) =>
  useQuery([USER, "profile", id], () => getUserProfileById(id), {
    enabled: !!id,
  });

const putUserProfile = ({ id, ...payload }) =>
  api.put(`${USER}/${id}`, payload);

export const usePutUserProfile = (id) => {
  const { addSnackbarSuccess, addSnackbarError } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(putUserProfile, {
    onSuccess: () => {
      invalidate(queryClient, USER);
      queryClient.invalidateQueries([USER, "profile", id]);
      addSnackbarSuccess({ message: "Profile updated" });
    },
    onError: (e) => {
      addSnackbarError({
        message: e?.response?.data || "Failed to update profile",
      });
    },
  });
};
